import { render, staticRenderFns } from "./CustomerStats.vue?vue&type=template&id=0669b57f&"
import script from "./CustomerStats.vue?vue&type=script&lang=js&"
export * from "./CustomerStats.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStats.vue?vue&type=style&index=0&scopped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports